<script>
import { getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'CheckMoreText',
  props: {
    color: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '查看更多'
    },
    icon: {
      type: String,
      default: 'el-icon-arrow-right'
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getPageThemeColor }
}
</script>

<template>
  <div class="check-more pointer" :style="{color: getPageThemeColor(path)}">
    <p class="check-more-text" :style="{color: color || getPageThemeColor(path)}">
      {{ text }} <i :class="icon" />
    </p>
  </div>
</template>

<style lang="scss" scoped>
.check-more {
  border-radius: 5px;
  display: inline-block;
  box-sizing: border-box;
  .check-more-text {
    font-size: 13px;
    font-weight: bold;
    i {
      font-weight: bold;
    }
  }
}
</style>
